




























































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import BeratBadan from "@/components/pemeriksaan/assesmen/BeratBadan.vue";
import Imt from "@/components/pemeriksaan/assesmen/Imt.vue";
import TinggiBadan from "@/components/pemeriksaan/assesmen/TinggiBadan.vue";
import LLA from "@/components/pemeriksaan/assesmen/LLA.vue";
// import Mual from "@/components/pemeriksaan/assesmen/Mual.vue";
// import Muntah from "@/components/pemeriksaan/assesmen/Muntah.vue";
import LingkarKepala from "@/components/pemeriksaan/assesmen/LingkarKepala.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";

@Component({
  components: {
    BeratBadan,
    Imt,
    TinggiBadan,
    LLA,
    // Mual,
    // Muntah,
    LingkarKepala
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class Antropometri extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop() antropometri!: object;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // antropometri = {};
  sess_login = userModule.user;
  getparam = {
    reg: this.register,
    unit_id: this.sess_login.unit_id
  };
  // antropometri = {};
  mounted() {
    // storeAntrompometri.clear_list_antropometri();
    // this.getAntropometri();
    // this.getListAntropometri();
    // console.log("antropometri", this.antropometri);
  }
  // get antropometri() {
  //   console.log("antro", this.antro);
  //   return this.antro;
  // }
  setBb(v) {
    // this.antropometri["berat_badan"] = v;
    this.antropometri["berat_badan"] = v;
  }
  setTb(v) {
    this.antropometri["tinggi_badan"] = v;
  }
  setImt(v) {
    this.antropometri["imt"] = v;
  }
  setLingkarKepala(v) {
    this.antropometri["lingkar_kepala"] = v;
  }
  setLla(v) {
    this.antropometri["lla"] = v;
  }

  @Watch("antropometri")
  changeAntropometri() {
    // console.log("antro");
    this.$emit("antropometri", this.antropometri);
    // this.$emit("antro", this.antropometri);
  }
}
